import BuildOutlinedIcon from '@mui/icons-material/BuildOutlined';
const icons = { BuildOutlinedIcon };

// ==============================|| MENU ITEMS - MAINTENACE MANAGEMENT ||============================== //

const maintenaceManagement = {
  id: 'group-maintenace-management',
  type: 'group',
  children: [
    {
      id: 'maintenance-management',
      title: 'Maintenance Management',
      type: 'collapse',
      icon: icons.BuildOutlinedIcon,
      children: [
        {
          id: 'service-schedules',
          title: 'Service Scheduling',
          type: 'item',
          url: '/service-schedules',
          icon: icons.BuildOutlinedIcon
        },
        {
          id: 'license-vehicle',
          title: 'License Vehicle',
          type: 'item',
          url: '/vehicle-license-reminder',
          icon: icons.BuildOutlinedIcon
        },
        {
          id: 'license-driver',
          title: 'License Driver',
          type: 'item',
          url: '/driver-license-reminder',
          icon: icons.BuildOutlinedIcon
        }
      ]
    }
  ]
};

export default maintenaceManagement;
